import { useEffect, useState } from 'react'

export const useWindow = (): Window | undefined => {
  const [w, setW] = useState<Window>()

  useEffect(() => {
    setW(window)
  }, [])

  return w
}
